(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  window.location.replace('/?open-cart');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const overlay = document.getElementById('menu-overlay');

  const drawer = document.getElementById('drawer-menu');
  const drawerOpener = document.querySelector('.drawer-menu-opener');
  const drawerCloser = document.querySelector('.drawer-menu-closer');

  const cartDrawer = document.getElementById('drawer-cart');
  const cartDrawerOpener = document.querySelector('.drawer-cart-opener');
  const cartDrawerCloser = document.querySelector('.drawer-cart-closer');

  // Function to open the cart
  function openCart() {
    cartDrawer.classList.remove('translate-x-full', 'opacity-0');
    cartDrawer.classList.add('translate-x-0', 'opacity-100');
    overlay.classList.remove('hidden');
    cartDrawerOpener.setAttribute('aria-expanded', 'true');
    cartDrawerCloser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden', 'cart-is-open');
  }

  // Open cart on "add to cart"
  document.addEventListener('liquid-ajax-cart:request-end', (event) => {
    const { requestState } = event.detail;
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      openCart();
    }
  });

  // Function to close the menu
  function closeCart() {
    cartDrawer.classList.add('translate-x-full', 'opacity-0');
    cartDrawer.classList.remove('translate-x-0', 'opacity-100');
    overlay.classList.add('hidden');
    cartDrawerOpener.setAttribute('aria-expanded', 'false');
    cartDrawerCloser.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden', 'cart-is-open');
  }

  // Function to open the menu
  function openMenu() {
    drawer.classList.remove('translate-x-full', 'opacity-0');
    drawer.classList.add('translate-x-0', 'opacity-100');
    overlay.classList.remove('hidden');
    drawerOpener.setAttribute('aria-expanded', 'true');
    drawerCloser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }

  // Function to close the menu
  function closeMenu() {
    drawer.classList.add('translate-x-full', 'opacity-0');
    drawer.classList.remove('translate-x-0', 'opacity-100');
    overlay.classList.add('hidden');
    drawerOpener.setAttribute('aria-expanded', 'false');
    drawerCloser.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  }

  function closeMenuOrCart() {
    if (!drawer.classList.contains('translate-x-full')) {
      closeMenu();
    }
    if (!cartDrawer.classList.contains('translate-x-full')) {
      closeCart();
    }
    return;
  }

  // Event listeners
  drawerOpener.addEventListener('click', openMenu);
  drawerCloser.addEventListener('click', closeMenu);
  cartDrawerOpener.addEventListener('click', openCart);
  cartDrawerCloser.addEventListener('click', closeCart);
  overlay.addEventListener('click', closeMenuOrCart);

  // Close the menu when pressing the "Escape" key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenuOrCart();
    }
  });

  // Open menu on ?open-cart
  function checkOpenCart() {
    // Check if the URL contains ?open-cart
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('open-cart')) {
      // Trigger your custom event or function here
      openCart();
    }
  }

  checkOpenCart();

  window.addEventListener('popstate', checkOpenCart);

  // Dropdowns
  const dropdowns = document.querySelectorAll('.dropdown');

  dropdowns.forEach(function (dropdown) {
    const dropdownTrigger = dropdown.querySelector('.dropdown-trigger');
    const dropdownMenu = dropdown.querySelector('.dropdown-menu');

    if (dropdownTrigger && dropdownMenu) {
      dropdownTrigger.addEventListener('click', function (event) {
        event.preventDefault();

        dropdowns.forEach(function (otherDropdown) {
          const otherDropdownMenu = otherDropdown.querySelector('.dropdown-menu');
          if (otherDropdown !== dropdown && otherDropdownMenu) {
            otherDropdownMenu.classList.remove('max-h-full');
            otherDropdownMenu.classList.add('max-h-0');
            otherDropdownMenu.classList.hidden('max-h-0');
            otherDropdown.classList.remove('active');
          }
        });

        const isDropdownVisible = dropdown.classList.contains('active');

        if (isDropdownVisible) {
          dropdownMenu.classList.remove('max-h-full');
          dropdownMenu.classList.add('max-h-0');
          dropdownMenu.classList.add('hidden');
          dropdown.classList.remove('active');
        } else {
          dropdownMenu.classList.remove('hidden');
          requestAnimationFrame(() => {
            dropdownMenu.classList.add('max-h-full');
            dropdownMenu.classList.remove('max-h-0');
          });
          dropdown.classList.add('active');
        }
      });
    }
  });

  const cartLineItems = document.querySelectorAll('.cart-line-item');

  if (cartLineItems) {
    cartLineItems.forEach(function (cartLineItem) {
      const cartLineItemDeliveryIntervalSelector = cartLineItem.querySelector('.delivery-interval-selector');
      if (cartLineItemDeliveryIntervalSelector) {
        cartLineItemDeliveryIntervalSelector.addEventListener('input', (event) => {
          if (cartLineItemDeliveryIntervalSelector.value == 'one-time') {
            const body = {
              id: cartLineItem.dataset.lineItemKey,
              quantity: cartLineItem.dataset.lineItemQuantity,
              selling_plan: null,
            };
            liquidAjaxCart.change(body);
          } else {
            const body = {
              id: cartLineItem.dataset.lineItemKey,
              quantity: cartLineItem.dataset.lineItemQuantity,
              selling_plan: cartLineItemDeliveryIntervalSelector.value,
            };
            liquidAjaxCart.change(body);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  window.location.replace('/');

  } catch(e) { console.error(e); }
})();
})();
